import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import * as React from 'react';
import {
    PageTitleAndText,
    StyledContainerGrid,
    StyledContainerGridItem
} from './SE360DuskPhotographerBooking';

const LoadingSkeletons = ({ labels }) => {
    return (
        <StyledContainerGrid container>
            <StyledContainerGridItem
                item
                flexDirection={'column'}
                alignItems={'flex-start'}
                sx={{ padding: '0px 10px 0px 10px' }}
            >
                <PageTitleAndText
                    pageTitle={labels.pageTitle}
                    pageParagraph={labels.pageParagraph}
                />
            </StyledContainerGridItem>
            <Divider sx={{ alignItems: 'center', margin: '24px 8px 10px 8px' }} />
            <Skeleton
                variant="rectangular"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    paddingTop: '32px 0px 20px 0px',
                    margin: 'auto',
                    width: '100%',
                    height: '72px'
                }}
            />

            <Skeleton
                variant="rectangular"
                sx={{
                    display: 'flex',
                    margin: '10px auto auto auto',
                    borderRadius: '6px',
                    padding: '0px 40px 0px 18px',
                    width: '100%',
                    height: '72px'
                }}
            />

            <Divider sx={{ alignItems: 'center', margin: '24px 8px 10px 8px' }} />
        </StyledContainerGrid>
    );
};

export default LoadingSkeletons;
